import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 广播服务{apiNoUse}
 */
export const SytemBrsd = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/brsd`, params);
};

/**
 * 最近添加客户
 */
export const RecentCustomerList = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/event/customer`, params);
};

/**
 * 最近添加设备模型
 */
export const RecentDeviceModelList = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/event/model`, params);
};

/**
 * 最近系统事件
 */
export const SystemEvent = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/event/system`, params);
};

/**
 * 最近添加用户
 */
export const RecentUserList = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/event/user`, params);
};

/**
 * 系统版本
 */
export const SystemInfo = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/info`, params);
};

/**
 * 客户统计
 */
export const CustomerStat = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/stat/customer`, params);
};

/**
 * 设备模型统计
 */
export const DeviceModelStat = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/stat/model`, params);
};

/**
 * 用户统计
 */
export const UserStat = params => {
  return request('get', `${baseUrl}/api/auth/sys/system/stat/user`, params);
};
